import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin: 100px 0 72px 0;

  @media ${({ theme }) => theme.devices.mobile} {
    margin: 40px 0;
    gap: 20px;
  }

  > img {
    width: 100%;
  }
`;
